/**
 * CADINU V2 pairs mint a protocol fee to feeTo on every mint/burn: 8/25 of the growth in sqrt(k) since kLast
 * (CadinuFactory_V2 _mintFee: liquidity = totalSupply * (rootK - rootKLast) * 8 / (rootK * 17 + rootKLast * 8)).
 * A burn is priced against totalSupply + that fee, so a removal quote that ignores it is too high. On
 * USDT/CADINU (no liquidity event since 2023) it was 1.06% too high, above the 0.5% slippage: every V2 removal
 * there reverted at the router (INSUFFICIENT_A_AMOUNT) and the UI only said "This transaction would fail".
 * kLast = 0 means no fee is pending. If feeTo was switched off while kLast is set, the pair mints nothing and this
 * over-estimates the dilution, which only lowers the quote: the safe side for a minimum.
 */
export function bigSqrt(v: bigint): bigint {
  if (v < 0n) throw new Error('sqrt of negative')
  if (v < 2n) return v
  let x = v
  let y = (x + 1n) / 2n
  while (y < x) {
    x = y
    y = (x + v / x) / 2n
  }
  return x
}

export function pendingProtocolFeeLiquidity(totalSupply: bigint, reserve0: bigint, reserve1: bigint, kLast: bigint): bigint {
  if (kLast === 0n || totalSupply === 0n) return 0n
  const rootK = bigSqrt(reserve0 * reserve1)
  const rootKLast = bigSqrt(kLast)
  if (rootK <= rootKLast) return 0n
  return (totalSupply * (rootK - rootKLast) * 8n) / (rootK * 17n + rootKLast * 8n)
}

/** totalSupply as the pair will see it inside burn(), after _mintFee. */
export function burnTotalSupply(totalSupply: bigint, reserve0: bigint, reserve1: bigint, kLast: bigint): bigint {
  return totalSupply + pendingProtocolFeeLiquidity(totalSupply, reserve0, reserve1, kLast)
}
